<template>
  <div id="pageDashboard">
    <support-layout v-if="visibleSupportLayout"></support-layout>
    <specialist-layout v-if="visibleSpecialistLayout"></specialist-layout>
  </div>
</template>

<script>
export default {
  components: {
    SupportLayout: () => import(/* webpackPrefetch: true */ './layouts/Support'),
    SpecialistLayout: () => import(/* webpackPrefetch: true */ './layouts/Specialist')
  },

  computed: {
    visibleSupportLayout () {
      return this.$store.getters.HAS_ROLE(['manager']) ||
        this.$store.getters.HAS_ROLE(['Técnico Soporte'])
    },
    visibleSpecialistLayout () {
      return this.$store.getters.HAS_ROLE(['manager']) ||
        this.$store.getters.HAS_ROLE(['Especialista de Servicios Generales'])
    }
  }
}
</script>

<style scoped>

</style>
